import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, MapIcon, CarIcon } from 'lucide-react';
const bonuses = [{
  icon: FileTextIcon,
  badge: 'BONUS #1',
  title: '24-Hour Blackout Survival Guide',
  description: 'Step-by-step protocol for the first critical hours without power.',
  value: '$27',
  image: 'https://cdn.magicpatterns.com/uploads/h4S9Udm8Xa8cRFW2ren1sr/MockUp_1.png',
  imageAlt: '24-Hour Blackout Survival Guide shown on tablet with emergency radio and headlamp'
}, {
  icon: MapIcon,
  badge: 'BONUS #2',
  title: 'Emergency Gear Master List',
  description: 'Field-tested equipment recommendations from preparedness experts.',
  value: '$17',
  image: 'https://cdn.magicpatterns.com/uploads/nSMbjZN34LLyR6R4nWkXJR/MockUp_2.png',
  imageAlt: 'Emergency Gear Master List displayed on laptop with detailed checklists and price comparisons'
}, {
  icon: CarIcon,
  badge: 'BONUS #3',
  title: 'Car Go-Bag Master Plan',
  description: 'Complete vehicle emergency kit blueprint for evacuation scenarios.',
  value: '$19',
  image: 'https://cdn.magicpatterns.com/uploads/eqcAFcrCNB4XmGm5JJAHh8/MockUp_3.png',
  imageAlt: 'Car Go-Bag Master Plan shown on phone with packed vehicle emergency kit'
}];
export function BonusSection() {
  return <section className="bg-light-gray py-20 px-4 border-b border-gray-200" data-id="element-12">
      <div className="max-w-7xl mx-auto" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <span className="font-heading text-sm font-bold text-navy tracking-[0.2em] uppercase mb-2 block" data-id="element-15">
            Included Supplements
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy" data-id="element-16">
            Act Now and Receive These Critical Supplements
          </h2>
          <div className="w-24 h-1 bg-navy mx-auto mt-6" data-id="element-17"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-18">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white border border-gray-300 shadow-document relative overflow-hidden flex flex-col h-full" data-id="element-19">
              {/* Top accent border */}
              <div className="absolute top-0 left-0 w-full h-1.5 bg-safety-red" data-id="element-20"></div>

              {/* "INCLUDED" Stamp */}
              <div className="absolute top-6 right-[-30px] bg-cta-green text-white font-heading text-[10px] font-bold uppercase tracking-widest py-1 px-10 transform rotate-45 shadow-sm" data-id="element-21">
                Included
              </div>

              {/* Bonus Image */}
              <div className="w-full bg-gray-100 p-4 flex items-center justify-center" data-id="element-22">
                <img src={bonus.image} alt={bonus.imageAlt} className="w-full h-auto object-contain max-h-56" data-id="element-23" />
              </div>

              <div className="p-8 flex-1 flex flex-col" data-id="element-24">
                <div className="inline-block bg-navy text-white font-heading text-xs font-bold px-3 py-1 uppercase tracking-widest mb-4 w-fit" data-id="element-25">
                  {bonus.badge}
                </div>

                <h3 className="font-heading font-bold text-xl text-navy mb-3 uppercase tracking-wide" data-id="element-26">
                  {bonus.title}
                </h3>

                <p className="font-body text-gray-700 flex-1" data-id="element-27">
                  {bonus.description}
                </p>

                <div className="mt-6 pt-4 border-t border-gray-200" data-id="element-28">
                  <p className="font-heading font-bold text-safety-red uppercase tracking-widest text-sm" data-id="element-29">
                    Value: {bonus.value}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}